module.exports = __webpack_public_path__ + "img/notify.4a9f586a.svg";